import React from 'react'
import { type AppBottomBarIconProps } from '../types'

export const MenuSVGIcon: React.FC<AppBottomBarIconProps> = ({ isActive }) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 20C11.7732 20 8.01436 22.0408 5.62129 25.208C5.10624 25.8896 4.84871 26.2304 4.85713 26.691C4.86364 27.0469 5.08711 27.4959 5.36712 27.7156C5.72955 28 6.23179 28 7.23627 28H24.7637C25.7681 28 26.2704 28 26.6328 27.7156C26.9128 27.4959 27.1363 27.0469 27.1428 26.691C27.1512 26.2304 26.8937 25.8896 26.3786 25.208C23.9856 22.0408 20.2267 20 16 20Z"
      stroke={isActive ? '#1B294C' : '#93979F'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 16C19.3137 16 22 13.3137 22 10C22 6.68629 19.3137 4 16 4C12.6863 4 9.99996 6.68629 9.99996 10C9.99996 13.3137 12.6863 16 16 16Z"
      stroke={isActive ? '#1B294C' : '#93979F'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
